/** Letters, digits and single dashes only (a safe, portable file name part). */
function asciiPart(s: string | null | undefined, max: number): string {
  return (s ?? '')
    .normalize('NFKD')
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, max)
    .replace(/-+$/, '');
}

/**
 * The name of the signed lease the resident downloads and keeps: the
 * organization's handle first for a verified brand (as the office's exports
 * are named), e.g. "young-eliyahu-lease-YE-1042-signed.pdf".
 */
export function leaseDownloadName(handle: string | null, contractNumber: string | null | undefined): string {
  const org = asciiPart(handle, 60);
  const num = asciiPart(contractNumber, 40);
  return [org, 'lease', num, 'signed'].filter(Boolean).join('-') + '.pdf';
}
